import { Directive, ElementRef, Input, DoCheck } from '@angular/core';

@Directive({
  selector: '[baseDynamicFontSize]',
})
/**
 * Simple directive for text element which reduce the font size dynamically based on text length<br/>
 * Available inputs: <br/>
 * - baseDynamicFontSize
 *  <br/>
 *  Please see description of each input to read about usage information
 */
export class BaseDynamicFontSizeDirective implements DoCheck {
  @Input() baseDynamicFontSize: number;
  /**
   * Takes an input value, which is the maximum length of text before the font size is reduced <br/>
   * If the length of the text is greater than input number of characters, the font size will be reduced to 12px. You can adjust these values as needed.
   */
  constructor(public hostElement: ElementRef) {}

  ngDoCheck(): void {
    const textLength = this.hostElement.nativeElement.innerText.length;
    if (textLength > this.baseDynamicFontSize) {
      this.hostElement.nativeElement.style.fontSize = '12px';
    }
  }
}
